import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import noop from 'lodash/noop';
import Button from 'wonderbly-components/lib/Button';
import './OrderButton.scss';

const OrderButton = ({ type, label, href, raised, outlined, disabled, handleOnClick = noop }) => {
  if (!label && !href) {
    return null;
  }

  return (
    <Button
      href={href}
      onClick={handleOnClick}
      className={cx('order-button', {
        [`order-button--${type}`]: type,
      })}
      colour="green"
      raised={raised}
      outlined={outlined}
      disabled={disabled}>
      {label}
    </Button>
  );
};

OrderButton.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  raised: PropTypes.bool,
  outlined: PropTypes.bool,
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func,
};

export default OrderButton;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderButtons/OrderButton/OrderButton.js